import { Reducer } from 'redux';
import { ActionType, getType } from 'typesafe-actions';
import { CardActions } from './CardActions';
import CardStateHelper from './CardStateHelper';
import CardsHelper from '../../Utility/CardsHelper';
import { IGameState } from '../Game/IGameState';
import { CardType } from 'Prototype/Level/Card/CardType';
import { CardModifierType } from 'Prototype/Level/Card/CardModifierType';
import { MatchCardSequence } from 'State/Level/ILevelState';
import { updateCardSequence } from 'State/Level/Action/IncrementCardSequence';

export const cardsHelper = new CardsHelper();

export const cardReducer: Reducer<IGameState> = (
    state: IGameState,
    action: ActionType<typeof CardActions>
): IGameState => {
    state = {
        ...state,
        levelState: {
            ...state.levelState,
            cardsState: {
                ...state.levelState.cardsState,
                cards: { ...state.levelState.cardsState.cards },
                tasks: [], // Tasks are cleared each turn.
                turnScore: 0,
            },
        },
    };

    switch (action.type) {
        case getType(CardActions.playCard):
            state = CardStateHelper.playCard(state, action.payload);
            break;
        case getType(CardActions.playBooster):
            state = CardStateHelper.playBooster(state, action.payload, {});
            break;
        case getType(CardActions.setCardInStackByIndex):
            state = {
                ...state,
                levelState: {
                    ...state.levelState,
                    cardsState: CardStateHelper.setCardInStackByIndex(
                        state.levelState.cardsState,
                        action.payload,
                        action.meta
                    ),
                },
            };
            break;
        case getType(CardActions.discardCards):
            state = CardStateHelper.setCardDiscarded(state, ...action.payload);
            let cardsState = CardStateHelper.checkCardsObscured(state.levelState.cardsState);
            state = CardStateHelper.updateGameState(state, cardsState);
            state = CardStateHelper.updateCards(state);
            break;
    }
    return {
        ...state,
        levelState: {
            ...state.levelState,
            score: state.levelState.score + state.levelState.cardsState.turnScore,
        },
    };
};

export function getMatchingCardsSequence(state: IGameState): IGameState {
    const matches = CardStateHelper.getCardMatches(state);
    const topStackCard = state.levelState.cardsState.inStack[state.levelState.cardsState.inStack.length - 1];
    const sequence: MatchCardSequence[] = [];
    if (matches.length === 0) {
        if (topStackCard !== undefined) sequence.push({ card: topStackCard });
    } else {
        matches.forEach((match) => {
            const card = state.levelState.cardsState.cards[match];
            const behavior = CardStateHelper.getCardBehavior(state.levelState.cardsState, match);
            switch (card.type) {
                case CardType.boom:
                case CardType.zap:
                case CardType.scissors:
                case CardType.tornado:
                case CardType.key:
                    sequence.push({ card: match, affectedCards: behavior.getAffectedCards(state) });
                    break;
                case CardType.lock:
                    break;
                case CardType.plus_three:
                case CardType.gold:
                    sequence.push({ card: match });
                    break;
                case CardType.value:
                    if (
                        state.levelState.cardsState.cards[match].modifiers.findIndex(
                            (modifier) => modifier.type === CardModifierType.pickaxe
                        ) !== -1
                    ) {
                        sequence.push({
                            card: match,
                            affectedCards: state.levelState.cardsState.inPlay.filter(
                                (card) => state.levelState.cardsState.cards[card].type === CardType.rock
                            ),
                        });
                    } else {
                        sequence.push({ card: match });
                    }
                    break;
                case CardType.rock:
                    break;
                case CardType.joker:
                    break;
            }
        });
    }
    state = {
        ...state,
        levelState: {
            ...state.levelState,
            cardMatchSequence: sequence,
        },
    };
    return updateCardSequence(state);
}
